import { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Stack, IconButton, Text } from '@fluentui/react'

type NavItem = {
  key: string
  label: string
  icon: string
  path: string
}

const navItems: NavItem[] = [
  { key: 'home', label: 'Home', icon: 'Home', path: '/' },
  { key: 'feedback', label: 'Feedback', icon: 'Feedback', path: '/feedback' },
  { key: 'conversations', label: 'Conversations', icon: 'Chat', path: '/conversations' },
  { key: 'performance', label: 'Performance & cost', icon: 'SpeedHigh', path: '/performance' },
  { key: 'llm-results', label: 'Monitoring Tests', icon: 'TestBeaker', path: '/llm-results' },
]

const COLLAPSED_WIDTH = 48
const EXPANDED_WIDTH = 220

const NavBar = () => {
  const [expanded, setExpanded] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/'
    return location.pathname.startsWith(path)
  }

  return (
    <Stack
      onMouseEnter={() => setExpanded(true)}
      onMouseLeave={() => setExpanded(false)}
      styles={{
        root: {
          width: expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
          minWidth: expanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH,
          backgroundColor: '#faf9f8',
          borderRight: '1px solid #edebe9',
          transition: 'width 0.2s ease, min-width 0.2s ease',
          overflow: 'hidden',
          paddingTop: 12,
        },
      }}
    >
      <Stack tokens={{ childrenGap: 2 }} styles={{ root: { padding: '0 4px' } }}>
        {navItems.map((item) => {
          const active = isActive(item.path)
          return (
            <Stack
              key={item.key}
              horizontal
              verticalAlign="center"
              onClick={() => navigate(item.path)}
              styles={{
                root: {
                  padding: expanded ? '10px 12px' : '10px 0',
                  justifyContent: expanded ? 'flex-start' : 'center',
                  borderRadius: 6,
                  cursor: 'pointer',
                  backgroundColor: active ? '#e1dfdd' : 'transparent',
                  selectors: {
                    ':hover': { backgroundColor: active ? '#e1dfdd' : '#f3f2f1' },
                  },
                },
              }}
              tokens={{ childrenGap: 10 }}
            >
              <IconButton
                iconProps={{ iconName: item.icon }}
                styles={{
                  root: {
                    color: active ? '#2B3A67' : '#605e5c',
                    width: 32,
                    height: 32,
                  },
                  rootHovered: { backgroundColor: 'transparent' },
                }}
                title={expanded ? undefined : item.label}
                ariaLabel={item.label}
                onClick={(e) => {
                  e.stopPropagation()
                  navigate(item.path)
                }}
              />
              {expanded && (
                <Text
                  styles={{
                    root: {
                      color: active ? '#2B3A67' : '#323130',
                      fontWeight: active ? 600 : 400,
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  {item.label}
                </Text>
              )}
            </Stack>
          )
        })}
      </Stack>
    </Stack>
  )
}

export default NavBar
